import React from "react";
import { Link } from "react-router-dom";
import { Button } from "antd";
import routes from "../../../../../routes";

const CartPaymentMethodPage = () => {
  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <h1 style={{ fontSize: "1.5rem", marginBottom: 30 }}>Select Address</h1>
        <Link to={routes.purchaseOrder}>
          <Button variant="primary">Proceed to Payment</Button>
        </Link>
      </div>
      <div>
        <p>Your order updates and invoices will be sent to user@example.com</p>
      </div>
    </div>
  );
};

export default CartPaymentMethodPage;
